import React from 'react'
import './skill.css'
import SkillCard from './SkillCard'

const Skill = () => {
  let skillInfo = [
    {
      id: 1,
      skillName: "HTML & CSS",
      percentage: "92",
    },
    {
      id: 2,
      skillName: "JavaScript (ES6)",
      percentage: "95",
    },
    {
      id: 2,
      skillName: "Bootstrap",
      percentage: "90",
    },
    {
      id: 3,
      skillName: "Tailwind Css",
      percentage: "70",
    },
    {
      id: 4,
      skillName: "React JS",
      percentage: "85",
    }
    ,
    {
      id: 5,
      skillName: "Json data & Rest API",
      percentage: "80",
    },
    {
      id: 6,
      skillName: "Redux & context api",
      percentage: "79",
    },
    {
      id: 7,
      skillName: "CMS (WordPress,WIX)",
      percentage: "70",
    }, {
      id: 8,
      skillName: "Next JS",
      percentage: "70",
    }, {
      id: 9,
      skillName: "Git & Github version controll",
      percentage: "70",
    }

  ]
  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Md Nazmul Hossain - Frontend Developer Portfolio | React.js Specialist</title>
        <meta name="description" content="Discover Md Nazmul Hossain's diverse skill set in web development, featuring expertise in HTML & CSS, JavaScript (ES6), Bootstrap, Tailwind CSS, React JS, JSON data & REST API integration, Redux & Context API usage, CMS platforms like WordPress and WIX, Next JS, and Git & GitHub version control. With proficiency levels ranging from 70% to 95%, Md Nazmul Hossain is equipped to create dynamic and responsive web applications that engage users effectively." />
      </head>
      <section id='skills'>
        <div className="container">
          <div className="skill-heading">
            <h1>My Skill</h1>
          </div>
          <div className="skill-container">

            {skillInfo.map((skills) => (
              <SkillCard key={skills.id} skills={skills} />
            ))}
          </div>
        </div>

      </section></>
  )
}

export default Skill